import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { OutletProvider } from "@/lib/outlets";
import LockScreen from "@/pages/LockScreen";
import Layout from "@/components/Layout";
import POS from "@/pages/POS";
import Admin from "@/pages/Admin";
import Reports from "@/pages/Reports";
import Dashboard from "@/pages/Dashboard";
import Expenses from "@/pages/Expenses";
import "@/App.css";

function Protected({ children }) {
  const { authed, checking } = useAuth();
  if (checking) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!authed) return <Navigate to="/lock" replace />;
  return children;
}

function RoleGuard({ children, perm, requireRole }) {
  const { role, can } = useAuth();
  if (requireRole && role !== requireRole) return <Navigate to={role === "viewer" ? "/dashboard" : "/"} replace />;
  if (perm && !can(perm)) return <Navigate to={role === "viewer" ? "/dashboard" : "/"} replace />;
  return children;
}

function RedirectIfAuthed({ children }) {
  const { authed, checking } = useAuth();
  if (checking) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (authed) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <OutletProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/lock" element={<RedirectIfAuthed><LockScreen /></RedirectIfAuthed>} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/" element={<RoleGuard perm="pos"><POS /></RoleGuard>} />
              <Route path="/dashboard" element={<RoleGuard perm="dashboard"><Dashboard /></RoleGuard>} />
              <Route path="/admin" element={<RoleGuard requireRole="owner"><Admin /></RoleGuard>} />
              <Route path="/reports" element={<RoleGuard perm="reports"><Reports /></RoleGuard>} />
              <Route path="/expenses" element={<RoleGuard perm="expenses"><Expenses /></RoleGuard>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </OutletProvider>
    </AuthProvider>
  );
}

export default App;
